// react
import React, { useEffect, useRef } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/modules/xrange';

export default function ActivationScheduleChart({
  activationRanges,
  baselineRanges,
  occupancyRanges,
  xAxis,
  height = 200,
  loading = false,
}) {
  const chartRef = useRef(null);

  React.useEffect(() => {
    if (chartRef.current) {
      const chart = chartRef.current.chart;
      if (loading) {
        chart.showLoading('Loading data...');
      } else {
        chart.hideLoading();
      }
    }
  }, [loading]);

  const options = {
    chart: {
      height,
      type: 'xrange',
      panning: true,
      panKey: 'shift',
      zooming: { type: 'x' },
      events: {
        load: function () {
          const chart = this;
          chart.customValueBox = chart.renderer
            .html('', chart.chartWidth - 80, 10)
            .css({ fontSize: '16px', textAlign: 'right' })
            .add();
        },
        redraw: function () {
          if (this.customValueBox) {
            this.customValueBox.attr({
              x: this.chartWidth - 80,
              y: 25,
            });
          }
        },
      },
    },
    time: { timezone: 'Europe/Copenhagen' },
    credits: { enabled: false },
    legend: { enabled: true },
    title: {
      text: 'Activation, Baseline and Occupancy Schedules',
      align: 'left',
      style: { fontSize: '14px' },
    },
    xAxis,
    yAxis: {
      categories: ['Activations', 'Baseline', 'Occupancy'],
      min: 0,
      max: 2,
      title: { text: '' },
    },
    series: [
      {
        name: 'Activations',
        data: activationRanges.map((r) => ({
          x: r.x,
          x2: r.x2,
          y: 0,
          on: r.on,
          color: r.on ? '#4caf50' : 'rgba(0,0,0,0)',
        })),
      },
      {
        name: 'Baseline Days',
        data: baselineRanges.map((r) => ({
          x: r.x,
          x2: r.x2,
          y: 1,
          isBaseline: true,
          color: 'rgb(0, 150, 196)', // blue translucent
          on: r.on,
        })),
      },
      {
        name: 'Occupancy',
        data: occupancyRanges.map((r) => ({
          x: r.x,
          x2: r.x2,
          y: 2,
          isOccupancy: r.isOccupancy,
          color: r.on ? 'rgb(124, 0, 196)' : 'rgba(0,0,0,0)', // blue translucent
          lineWidth: 0,
          on: r.on,
        })),
      },
    ],
  };

  useEffect(() => {
    if (chartRef.current && chartRef.current.chart) {
      chartRef.current.chart.redraw();
    }
  }, [activationRanges, baselineRanges, occupancyRanges]);

  return (
    <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
  );
}

// import React, { useRef, useEffect } from 'react';
// import Highcharts from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';
// import xrange from 'highcharts/modules/xrange';

// xrange(Highcharts);

// export default function ActivationScheduleChart({ data, xAxis }) {
//   const chartRef = useRef(null);

//   const options = {
//     chart: {
//       type: 'xrange',
//       zooming: { type: 'x' },
//       events: {
//         load: function () {
//           const chart = this;
//           chart.customValueBox = chart.renderer
//             .html('', chart.chartWidth - 80, 10)
//             .css({ fontSize: '16px', textAlign: 'right' })
//             .add();
//         },
//         redraw: function () {
//           if (this.customValueBox) {
//             this.customValueBox.attr({
//               x: this.chartWidth - 80,
//               y: 25,
//             });
//           }
//         },
//       },
//     },
//     credits: { enabled: false },
//     legend: { enabled: false },
//     title: { text: 'Activation Schedules', align: 'left' },
//     xAxis,
//     yAxis: { categories: ['Active'], min: 0, max: 0, title: { text: '' } },
//     tooltip: { enabled: true }, // disable default tooltip
//     series: [
//       {
//         name: 'Schedule',
//         data: data.map((r) => ({
//           x: r.x,
//           x2: r.x2,
//           y: r.y,
//           on: r.on,
//           color: r.on ? '#4caf50' : 'rgba(0,0,0,0)', // transparent for off
//         })),
//       },
//     ],
//   };

//   useEffect(() => {
//     if (chartRef.current && chartRef.current.chart) {
//       chartRef.current.chart.redraw();
//     }
//   }, [data]);

//   return (
//     <HighchartsReact
//       highcharts={Highcharts}
//       options={options}
//       ref={chartRef}
//       containerProps={{ style: { height: 150, margin: 10 } }}
//     />
//   );
// }
